import { gql } from '@apollo/client';

export const GET_MODEL_INPUTS_CONFIG_QUERY = gql`
  query nexusModelInputsConfig {
    nexusModelInputsConfig {
      items {
        key
        name
        order
      }
    }
  }
`;

export const GET_MODEL_INPUTS_ASSETS_QUERY = gql`
  query nexusModelInputsAssets($assetUuid: String!, $group: String!) {
    nexusModelInputsAssets(assetUuid: $assetUuid, group: $group) {
      items {
        name
        type
        validation
        value
        key
      }
    }
  }
`;

export const UPDATE_MODEL_INPUTS_ASSETS_MUTATION = gql`
  mutation nexusUpdateModelInputsAssets($assetUuid: String!, $group: String!, $items: [JSON!]!) {
    nexusUpdateModelInputsAssets(assetUuid: $assetUuid, group: $group, items: $items) {
      success
      message
    }
  }
`;
